export const environment = {
  production: true,
  firebaseEnv: {
    apiKey: 'AIzaSyBRyI3wIMkmq7TcyL7t-TORw_UaiuYrMQc',
    authDomain: 'rewirenpc.firebaseapp.com',
    databaseURL: 'https://rewirenpc.firebaseio.com',
    projectId: 'rewirenpc',
    storageBucket: 'rewirenpc.appspot.com',
    messagingSenderId: '203397110020',
    appId: '1:203397110020:web:3d9630ee4e3e8bde081851'
  },
  appCheck: {
    siteKey: '6Lde5LUsAAAAAPDXoXNI0H-APf1msdJ7mpYNufND'
  },
  // Real College Board login only in production.
  allowMockEclLogin: false,
  isAdminPreview: false,
  version: '3.0.7'
};
